<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 class="fronttitle paired">Contents</h1>
<hr/>
<p class="toc sub"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc sub"><a href="#/contents">Contents</a></p>
<p class="toc sub"><a href="#/front01">Copyright</a></p>
<p class="toc sub"><a href="#/front02">Dedication</a></p>
<p class="toc"><a href="#/c01">1</a></p>
<p class="toc"><a href="#/c02">2</a></p>
<p class="toc"><span href="#/c03" title="Link target outside of Sample">3</span></p>
<p class="toc"><span href="#/c04" title="Link target outside of Sample">4</span></p>
<p class="toc"><span href="#/c05" title="Link target outside of Sample">5</span></p>
<p class="toc"><span href="#/c06" title="Link target outside of Sample">6</span></p>
<p class="toc"><span href="#/c07" title="Link target outside of Sample">7</span></p>
<p class="toc"><span href="#/c08" title="Link target outside of Sample">8</span></p>
<p class="toc"><span href="#/c09" title="Link target outside of Sample">9</span></p>
<p class="toc"><span href="#/c10" title="Link target outside of Sample">10</span></p>
<p class="toc"><span href="#/c11" title="Link target outside of Sample">11</span></p>
<p class="toc"><span href="#/c12" title="Link target outside of Sample">12</span></p>
<p class="toc"><span href="#/c13" title="Link target outside of Sample">13</span></p>
<p class="toc"><span href="#/c14" title="Link target outside of Sample">14</span></p>
<p class="toc"><span href="#/c15" title="Link target outside of Sample">15</span></p>
<p class="toc sub"><span href="#/back01" title="Link target outside of Sample">Coming Soon: AUNTIE POLDI AND THE LOST MADONNA</span></p>
<p class="toc sub"><span href="#/back02" title="Link target outside of Sample">About the Author</span></p>
<p class="toc sub"><span href="#/back03" title="Link target outside of Sample">Connect with HMH</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?380ba1a9